import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  LocalShippingOutlined,
  LocationOnOutlined,
  InventoryOutlined,
  CalendarTodayOutlined,
  InfoOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetDataIntegrationDetailQuery } from "store/services/dataIntegrationApi";

const DataIntegrationInfoScreen = ({ integrationId }) => {
  const breadcrumbs = [
    {
      title: "Data Integration Info",
    },
  ];

  // RTK Query
  const {
    data: dataIntegrationDetail,
    isLoading: loadingDataIntegration,
    error,
  } = useGetDataIntegrationDetailQuery(integrationId);

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingDataIntegration}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingDataIntegration ? (
          <Box padding={3}>
            <Typography variant="h6">
              {dataIntegrationDetail?.dataIntegration_name || "Data Integration Details"}
            </Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalShippingOutlined color="primary" />}
                  title="Integration Id"
                  subtitle={dataIntegrationDetail?.integrationId || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocationOnOutlined color="primary" />}
                  title="Status Update"
                  subtitle={dataIntegrationDetail?.statusUpdate || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InventoryOutlined color="primary" />}
                  title="Document Type"
                  subtitle={dataIntegrationDetail?.documentType || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Status"
                  subtitle={dataIntegrationDetail?.status || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InfoOutlined color="primary" />}
                  title="External System Id"
                  subtitle={dataIntegrationDetail?.externalSystemId || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InventoryOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={dataIntegrationDetail?.status === "active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DataIntegrationInfoScreen;
